export default "__VITE_ASSET__0ef2aa58__"